<template>

  <div class="SiteContainer">
    <div class="standard-grid">
      <div>{{ store.scores }}</div>
      <button class="btn-secondary" @click="codeDomain('1')">Code Domain 1</button>
      <div>{{ domain1Code }}</div>
      <br>
      <br>
      <button class="btn-secondary" @click="encode()">Encode</button>
      <div>{{ temp }}</div>
      <br>
      <br>
      <button class="btn-secondary" @click="decode('ZZZZZZZZy')">Decode</button>
      <div>{{ temp2 }}</div>
      <br>
      <br>
      <div>{{ temp3 }}</div>
    </div>
  </div>
</template>
  
  <script>
  import { store } from '../store.js'
  export default {
    name: 'CodedScoresPage',
    components: {  },
    data() {
      return {
        store,
        domain1Code: [],
        temp: "",
        temp2: "",
        temp3: "",
        combinations: {
          uuu: "a",
          uun: "b",
          uup: "c",
          uuy: "d",
          unu: "e",
          unn: "f",
          unp: "g",
          uny: "h",
          upu: "i",
          upn: "j",
          upp: "k",
          upy: "l",
          uyu: "m",
          uyn: "n",
          uyp: "o",
          uyy: "p",
          nuu: "q",
          nun: "r",
          nup: "s",
          nuy: "t",
          nnu: "u",
          nnn: "v",
          nnp: "w",
          nny: "x",
          npu: "y",
          npn: "z",
          npp: "0",
          npy: "1",
          nyu: "2",
          nyn: "3",
          nyp: "4",
          nyy: "5",
          puu: "6",
          pun: "7",
          pup: "8",
          puy: "9",
          pnu: "-",
          pnn: "_",
          pnp: "A",
          pny: "B",
          ppu: "C",
          ppn: "D",
          ppp: "E",
          ppy: "F",
          pyu: "G",
          pyn: "H",
          pyp: "I",
          pyy: "J",
          yuu: "K",
          yun: "L",
          yup: "M",
          yuy: "N",
          ynu: "O",
          ynn: "P",
          ynp: "Q",
          yny: "R",
          ypu: "S",
          ypn: "T",
          ypp: "U",
          ypy: "V",
          yyu: "W",
          yyn: "X",
          yyp: "Y",
          yyy: "Z",
        }
      }
    },
    methods: {
      codeDomain(domain) {
        var domainScores = this.store.scores[domain]
        var scoresList = []
        for (var question of this.store.questions['section' + domain]) {
          var qref = question.ref
          console.log('out', domainScores[qref])
          console.log('question', qref)
          if (typeof (domainScores[qref]) === 'undefined') {
            console.log("None")
            scoresList.push("u")
          } else if (domainScores[qref] === '0') {
            console.log(domainScores[qref])
            scoresList.push("n")
          } else if (domainScores[qref] === '1') {
            scoresList.push("p")
          } else if (domainScores[qref] === '2') {
            scoresList.push("y")
          } else {
            scoresList.push("error")
          }
        }
        this.domain1Code = scoresList
        return scoresList
      },
      lookupAnswers(arr, obj) {
        // Takes an array of letters and chunks them into groups of 3. Each group is then encoded
        // to a url-safe base64 using the combinations object. Since there are 25 questions, once
        // the answers have been chunked in groups of 3, there will be 1 letter remaining. This letter
        // is just passed through without being encoded.
        const answers = [];

        for (let i = 0; i < arr.length; i += 3) {
          const chunk = arr.slice(i, i + 3).join('');
          if (obj[chunk]) {
            answers.push(obj[chunk]);
          } else {
            answers.push(chunk); // 3 x 8 = 24. The 25th question isn't encoded
          }
        }
        this.temp = answers

        return answers;
      },
      encode() {
        var all_answers = this.codeDomain(1).concat(this.codeDomain(2).concat(this.codeDomain(3).concat(this.codeDomain(4))))
        var encoded = this.lookupAnswers(all_answers, this.combinations)
        this.temp = encoded.join("");
      },
      decode(shortcode) {
        var codedArray = shortcode.split("")
        this.temp2 = codedArray;
        var lastAnswer = codedArray.pop()
        console.log(lastAnswer)
        var answers = this.getKeysFromArray(codedArray, this.combinations).concat([lastAnswer])
        var newScores = this.generateObjectFromArray(answers)
        this.temp2 = newScores
        if (this.temp2 === this.store.scores) {
          this.temp3 = 'Match'
        } else {
          this.temp3 = 'Nope'
        }
      },
      getKeysFromArray(arr, obj) {
        const keysArray = [];

        while (arr.length > 0) {
          const letter = arr.shift();
          const key = Object.keys(obj).find(key => obj[key] === letter);
          if (key) {
            keysArray.push(key);
          } else {
            keysArray.push(null); // or any default value for unmatched letters
          }
        }

        return keysArray.join('').split('');
      },
      generateObjectFromArray(arr) {
        const obj = {};
        let index = 0;

        const domains = [4, 7, 9, 5]; // Number of entries in each domain

        for (let i = 0; i < domains.length; i++) {
          obj[i + 1] = {}; // Initialize each domain as an empty object

          for (let j = 1; j <= domains[i]; j++) {
            const letter = arr[index];
            let value = '';

            if (letter === 'y') {
              value = '2';
            } else if (letter === 'n') {
              value = '0';
            } else if (letter === 'p') {
              value = '1';
            }

            if (value !== '') {
              obj[i + 1][j] = value;
            }

            index++;
          }
        }

        return obj;
      }
  }
  }
      
</script>

<style scoped>

</style>